import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import IRescheduleEligibilityRepository, {
  TRescheduleEligibility,
} from 'shared/domain/repositories/IRescheduleEligibilityRepository';

export default class VectisRescheduleEligibilityRepository
  implements IRescheduleEligibilityRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public async findOne(scheduleId: number): Promise<TRescheduleEligibility> {
    const { elegivel, mensagem } = await this.httpProvider.get<{
      elegivel: boolean;
      mensagem: string;
    }>(`/agendas/${scheduleId}/reagendamento/elegibilidade`, {
      // Elegibilidade muda a qualquer momento (pendência financeira) - nunca pode vir de cache
      params: { _t: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
    });

    return { eligible: elegivel, reason: mensagem };
  }
}
